module.exports = __webpack_public_path__ + "img/about_img.996d35e7.png";